<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentcolor">
    <path
      d="M16.232 9.225a2.611 2.611 0 0 0 2.613-2.612A2.611 2.611 0 0 0 16.232 4a2.611 2.611 0 0 0-2.613 2.613 2.611 2.611 0 0 0 2.613 2.612ZM16.232 10.611a5.733 5.733 0 0 0-4.082 1.703A7.342 7.342 0 0 0 2 19.092c0 .459.376.835.835.835h13.013c.46 0 .835-.376.835-.835a7.4 7.4 0 0 0-.25-1.887h4.732c.46 0 .835-.375.835-.834 0-3.18-2.588-5.76-5.76-5.76h-.008ZM9.337 10.36a3.185 3.185 0 0 0 3.18-3.18A3.185 3.185 0 0 0 9.338 4a3.185 3.185 0 0 0-3.18 3.18 3.185 3.185 0 0 0 3.18 3.18Z"
    />
  </svg>
</template>

<script>
export default {};
</script>
